import Icon from '../components/Icon.vue'

Icon.register({"filter":{"width":1408,"height":1792,"paths":[{"d":"M1403 295q17 41-14 70l-493 493v742q0 42-39 59-13 5-25 5-27 0-45-19l-256-256q-19-19-19-45v-486l-493-493q-31-29-14-70 17-39 59-39h1280q42 0 59 39z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/filter.js
// module id = 1088
// module chunks = 0